import { render, staticRenderFns } from "./VisitorPhone.vue?vue&type=template&id=52ce2d3e&scoped=true&"
import script from "./VisitorPhone.vue?vue&type=script&lang=js&"
export * from "./VisitorPhone.vue?vue&type=script&lang=js&"
import style0 from "./VisitorPhone.vue?vue&type=style&index=0&id=52ce2d3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce2d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})
